if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}


// WEBPACK FOOTER //
// ./src/common/general/js/polyfills/String.startsWith.js